import { BaseOption } from 'ui/selectv2/types';

export const getValuesFromOptions = (options: BaseOption<string>[]) =>
  options.map(({ value }) => value);
